var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "rbacServicesModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header modal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.cancelPermissions },
              },
              [_vm._v("×")]
            ),
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.selectedRoleName)),
            ]),
            _c("hr"),
          ]),
          _c(
            "div",
            { staticClass: "modal-body service-access" },
            [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button float-right",
                    on: { click: _vm.addService },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Add Service "),
                  ]
                ),
              ]),
              _vm.roleServices.length
                ? _c(
                    "div",
                    { staticClass: "col-md-12 col-sm-12 col-xs-12 pt-5" },
                    [
                      _vm._m(0),
                      _vm._l(_vm.roleServices, function (service, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "col-md-12 col-sm-12 col-xs-12 bt-border",
                          },
                          [
                            _c("div", { staticClass: "row pb-8 pt-8" }, [
                              _c(
                                "div",
                                { staticClass: "col-sm-6 col-xs-6 pd" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "checkbox inline-checkbox" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: service.access,
                                              expression: "service.access",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              service.access
                                            )
                                              ? _vm._i(service.access, null) >
                                                -1
                                              : service.access,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = service.access,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      service,
                                                      "access",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      service,
                                                      "access",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(service, "access", $$c)
                                              }
                                            },
                                          },
                                        }),
                                        _c("span", { staticClass: "cr" }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cust_label label-selected",
                                    },
                                    [_vm._v(_vm._s(service.name))]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "col-sm-3 col-xs-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "edit-lnk",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openPermissionsPopup(service)
                                      },
                                    },
                                  },
                                  [_vm._v("edit")]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-3 col-xs-4 xs-pd-lt-10",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-color-delete-red",
                                      attrs: {
                                        disabled:
                                          service.name == "Smart Exchange" ||
                                          service.name == "Smart Builder" ||
                                          service.name == "Launchpad" ||
                                          service.name ==
                                            "Regulatory Watch Admin" ||
                                          service.name ==
                                            "Representation Resources",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteService(service.name)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "tracker-images",
                                        attrs: {
                                          src: "/static/images/icons/delete_icon.svg",
                                          alt: "delete-icon",
                                        },
                                      }),
                                      _c("span", [_vm._v("Delete")]),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.addServiceFlag
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-12 col-xs-12 col-md-12 operations mb-80",
                      },
                      [
                        _vm._v(" Add Services "),
                        _c("div", { staticClass: "row label_container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-6 col-xs-6 custom-dropdown",
                            },
                            [
                              _c(
                                "multiselect",
                                {
                                  staticClass: "multiselect-single-dropdown",
                                  class: !_vm.addServiceSelected
                                    ? "un-selected"
                                    : "",
                                  attrs: {
                                    showLabels: false,
                                    "close-on-select": true,
                                    "allow-empty": false,
                                    searchable: true,
                                    options: _vm.addServices.map(
                                      (service) => service.id
                                    ),
                                    "custom-label": (option) =>
                                      _vm.addServices.find(
                                        (service) => service.id == option
                                      ).name,
                                    placeholder: "Select Service",
                                  },
                                  on: { input: _vm.addServiceToList },
                                  model: {
                                    value: _vm.addServiceSelected,
                                    callback: function ($$v) {
                                      _vm.addServiceSelected = $$v
                                    },
                                    expression: "addServiceSelected",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "noResult" },
                                      slot: "noResult",
                                    },
                                    [_vm._v("No matching data")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
            },
            [
              _c(
                "div",
                { staticClass: "col-xs-offset-4 col-xs-12 update-note" },
                [_vm._v(" Note: changes will override user customizations ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-md-offset-6 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelPermissions },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: { type: "button", disabled: _vm.loaderStatus },
                      on: { click: _vm.saveServices },
                    },
                    [_vm._v(" Save ")]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c("rbac-modules-modal", {
        attrs: { roleServices: _vm.roleServices, serviceId: _vm.serviceId },
        on: {
          updatePermissions: _vm.updatePermissions,
          updateServiceId: _vm.updateServiceId,
        },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 bt-border" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6 col-xs-5 pd" }, [
            _vm._v("Services access"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-2 txt-alg-rt" }, [
            _vm._v("Permissions"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-5 xs-pd-lt-50" }, [
            _vm._v("Action"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }